import React, { PureComponent } from 'react';

import { Button } from '@mui/material';

import PageContainer from '../../common/components/Page/PageContainer';
import Tile from '../../common/components/Tile/Tile';
import TableEnhancedContainer from '../../common/components/TableEnhanced/TableEnhancedContainer';
import Loading from '../../common/components/Loading/Loading';
import ChatStateEnum from '../../common/constants/ChatStateEnum';

class ChatManagement extends PureComponent {
  constructor(props) {
    super();

    this.styleConfig = {
      width: '10%',
    };

    this.columnsConfig = [
      {
        name: 'Date',
        key: 'Requested',
        type: 'datetime',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'SerialNumber',
        key: 'DeviceSerialNumber',
        type: 'string',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Instrument type',
        key: 'InstrumentType',
        type: 'string',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Software version',
        key: 'DeviceSoftwareVersion',
        type: 'string',
        visible: false,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Region',
        key: 'Region',
        type: 'string',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Group',
        key: 'Group',
        type: 'string',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Location',
        key: 'Location',
        type: 'string',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Device address',
        key: 'DeviceAddress',
        type: 'string',
        visible: false,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Status',
        key: 'State',
        type: 'string',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Device language',
        key: 'DeviceLanguage',
        type: 'string',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Operator name',
        key: 'OperatorName',
        type: 'string',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Actions',
        key: 'Actions',
        type: 'markup',
        style: this.styleConfig,
        markup: (el, col, elIndex, colIndex) => {
          return (
            <div>
              <Button
                variant="contained"
                data-qa="qa-openSession"
                color="primary"
                onClick={() => {
                  return props.onClickOpenSession(
                    el.WebClientUri,
                    el.CorrelationId,
                    el.DeviceSerialNumber
                  );
                }}
                disabled={el.State !== ChatStateEnum.REQUESTING.name}
              >
                Open
              </Button>
            </div>
          );
        },
        visible: true,
        filterable: false,
        sortable: false,
      },
    ];
  }

  render() {
    return (
      <PageContainer pageName="chat-management">
        <Loading condition={this.props.isFetching}>
          <Tile title="Chat sessions" helpTag="chat_management">
            <TableEnhancedContainer
              {...this.props.data}
              columns={this.columnsConfig}
              enableHideColumns={true}
              enableActionButtons={false}
              data-qa="qa-table-chatSessions"
            />
          </Tile>
        </Loading>
      </PageContainer>
    );
  }
}

export default ChatManagement;
